<template>
  <div
    id="livechat_pagelist"
    style="overflow-y: auto; border-right: 1px solid #eee"
    v-resize="onResizeToolList"
    :style="{ height: pagelistHeight + 'px' }"
  >
    <template v-for="(bot, bindex) in optionBotlist">
      <div :id="`bot_${bot.value}`" class="page" :key="`bot_${bindex}`">
        <v-badge v-model="bot.isLock" overlap color="info" style="">
          <template v-slot:badge>
            <v-icon dark small>lock</v-icon>
          </template>
          <div
            class="pa-2 img"
            :class="{
              active: value == bot.value,
              primary: value == bot.value,
              islock: bot.isLock
            }"
            @click="selectPage(bot, bot.isLock)"
          >
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-avatar v-on="on">
                  <img
                    class="responsive-img circle"
                    style="min-width: 100%"
                    alt
                    :src="
                      'https://graph.facebook.com/' +
                      bot.value +
                      '/picture?width=100&height=100&SameSite=None'
                    "
                  />
                </v-avatar>
              </template>
              <span>{{ bot.name }}</span>
            </v-tooltip>
          </div>
        </v-badge>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['value'],
  data() {
    return {
      pagelistHeight: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    optionBotlist: function () {
      return this.botlist
        .map((el) => {
          var isLock = !(
            this.$store.state.livechatPageList.includes(el.theme) ||
            this.$store.state.livechatPageIdList.includes(el.pageid) ||
            (el.theme == 'ecommercebasic' && el.pageid == '270028443161479') ||
            el.isUnlockLivechat
          )
          return { name: el.pagename, value: el.pageid, isLock: isLock, theme: el.theme }
        })
        .filter((el) => {
          return el != null
        })
        .sort((a, b) => {
          var nameA = a.name.toUpperCase() // ignore upper and lowercase
          var nameB = b.name.toUpperCase() // ignore upper and lowercase
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
    }
  },
  async mounted() {
    await this.$nextTick()
    if (this.$el.querySelector(`#bot_${this.value}`)) {
      this.$el.querySelector(`#bot_${this.value}`).scrollIntoView()
    }
  },
  methods: {
    selectPage(bot, isLock) {
      if (isLock) {
        return false
      }
      this.$store.commit('SELECT_PAGE_LIVECHAT', bot)
      this.$emit('changePage', bot.pageid)
    },
    onResizeToolList: function () {
      var vm = this
      vm.$nextTick(function () {
        vm.pagelistHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight
      })
    }
  },
  watch: {
    value(newVal) {
      if (newVal && this.$el.querySelector(`#bot_${newVal}`)) {
        this.$el.querySelector(`#bot_${newVal}`).scrollIntoView()
        this.$store.dispatch('forceLoadLastestUsers').then(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  .img {
    cursor: pointer;
    &.active {
      cursor: pointer;
    }

    &.islock {
      filter: grayscale(100%);
      cursor: not-allowed;
    }
  }
}
</style>

<style lang="scss">
.page .v-badge--overlap .v-badge__badge {
  top: 1px;
  right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-pagelist.vue